module.exports = __webpack_public_path__ + "static/media/design-img-2.f306190c.jpg";